import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconMessageCircle = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--message-circle")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M4.58286793,19.418893 L8.38550134,18.1513485 C8.6384472,18.0670332 8.91459052,18.0872235 9.15258246,18.2074338 C10.1901113,18.7314921 11.3367562,19.0030658 12.5013422,19.0000319 C15.3415547,18.9989329 17.9374826,17.3935564 19.2091311,14.8491785 C19.7331893,13.8116496 20.0047631,12.6650048 20.0017325,11.5026391 L20.0032475,11.0551173 C19.7932256,7.24824762 16.7535133,4.20853537 13.0017291,4.00000334 L12.4991218,4.00000334 C11.3367562,3.99699783 10.1901113,4.26857161 9.14878785,4.79453643 C6.60820452,6.06427837 5.00282805,8.66020627 5.0017257,11.5026391 C4.9986951,12.6650048 5.27026888,13.8116496 5.79432714,14.8491785 C5.91453742,15.0871704 5.93472769,15.3633137 5.8504124,15.6162596 L4.58286793,19.418893 Z M22.0017576,11.4987649 C22.0053688,12.975676 21.6602057,14.4325809 20.9962337,15.7470906 C19.3878939,18.9651628 16.0997186,20.9986397 12.5043364,21.0000284 C11.1692652,21.0035093 9.85051152,20.7219644 8.63567774,20.1761415 L3.31795687,21.9487151 C2.53619884,22.2093011 1.7924598,21.4655621 2.05304581,20.6838041 L3.82561905,15.3660843 C3.27979641,14.1512694 2.99825129,12.8327093 3.00172918,11.4996449 C3.00312127,7.90204237 5.03659813,4.61386703 8.25087574,3.0074338 C9.56957773,2.34135433 11.0269664,1.99618333 12.5017291,2 L13.0568145,2.00155019 C17.8815637,2.26772767 21.7340333,6.1201972 22.0017576,11.0000318 L22.0017576,11.4987649 Z" id="icon--centivo--message-circle"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1761.000000, -749.000000)"/>
          <g id="Icon/message-circle">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--message-circle"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--message-circle"/>
          </g>
      </g>
  </IconWrapper>
)
